/**
 * Mention types - mirrors the API's MentionType enum.
 * Used to distinguish kinds of inline mentions (resources, matters, statuses, ...)
 * embedded in rich text content such as notes and notifications.
 */
export enum MentionType {
  Resource = 1,
  Matter = 2,
  TimeOffRequestStatus = 3,
  Request = 4,
}
